"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Type = void 0;

var _upperFirst2 = _interopRequireDefault(require("lodash/upperFirst"));

var _isString2 = _interopRequireDefault(require("lodash/isString"));

var _get2 = _interopRequireDefault(require("lodash/get"));

var _props = require("../styles/props");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/**
 * Text elements.
 */


var textElements = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'label', 'small', {
  element: 'p',
  name: 'Paragraph'
}];
/**
 * Parse type element.
 */

function parseTypeElement(element) {
  if (!(0, _isString2.default)(element)) {
    return element;
  }

  return {
    element: element,
    name: (0, _upperFirst2.default)(element)
  };
}
/**
 * Set type style.
 */


var setTypeStyle = function setTypeStyle(element) {
  return function (_ref) {
    var theme = _ref.theme;
    var commonStyles = (0, _get2.default)(theme, 'typography.fontSettings', '');
    var typeStyles = (0, _get2.default)(theme, ['typography', 'styles', element], '');
    return (0, _styledComponents.css)(["", " ", ""], commonStyles, typeStyles);
  };
};
/**
 * Export `Type` component.
 */
// $FlowFixMe


var Type = textElements.reduce(function (result, item) {
  var _parseTypeElement = parseTypeElement(item),
      element = _parseTypeElement.element,
      name = _parseTypeElement.name;

  var StyledElement = (0, _styledComponents.default)(element).withConfig({
    displayName: "typography__StyledElement",
    componentId: "sc-1ka9yge-0"
  })(["", " ", ""], setTypeStyle(element), _props.setStyledProps);
  return _objectSpread({}, result, _defineProperty({}, name, StyledElement));
}, {});
exports.Type = Type;